import React from 'react';
import { Award, Briefcase, Users, FileText } from 'lucide-react';
export function CareerOutcomes() {
  return <section className="mb-12" data-id="element-146">
      <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-147">Course Benefits</h2>
      <p className="text-gray-700 mb-6" data-id="element-148">At the end of this course, you will:</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-149">
        <div className="bg-white rounded-xl p-6 border-2 border-blue-100 hover:border-blue-300 hover:shadow-lg transition-all duration-300" data-id="element-150">
          <div className="flex items-start gap-4" data-id="element-151">
            <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-152">
              <Award className="w-6 h-6 text-blue-600" data-id="element-153" />
            </div>
            <div data-id="element-154">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-155">
                Recognized Certificate
              </h3>
              <p className="text-gray-700" data-id="element-156">
                Earn a recognized Executive Assistant Certificate
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 border-2 border-green-100 hover:border-green-300 hover:shadow-lg transition-all duration-300" data-id="element-157">
          <div className="flex items-start gap-4" data-id="element-158">
            <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-159">
              <FileText className="w-6 h-6 text-green-600" data-id="element-160" />
            </div>
            <div data-id="element-161">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-162">
                Professional Portfolio
              </h3>
              <p className="text-gray-700" data-id="element-163">
                Build a portfolio of templates, systems, and tools to use in
                real jobs
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 border-2 border-blue-100 hover:border-blue-300 hover:shadow-lg transition-all duration-300" data-id="element-164">
          <div className="flex items-start gap-4" data-id="element-165">
            <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-166">
              <Users className="w-6 h-6 text-blue-600" data-id="element-167" />
            </div>
            <div data-id="element-168">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-169">Career Support</h3>
              <p className="text-gray-700" data-id="element-170">
                Boost your employability with support from SkillzHQ's
                recruitment partners
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 border-2 border-green-100 hover:border-green-300 hover:shadow-lg transition-all duration-300" data-id="element-171">
          <div className="flex items-start gap-4" data-id="element-172">
            <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-173">
              <Briefcase className="w-6 h-6 text-green-600" data-id="element-174" />
            </div>
            <div data-id="element-175">
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-176">
                Job Opportunities
              </h3>
              <p className="text-gray-700" data-id="element-177">
                Apply for internship or entry-level EA opportunities
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}